import { render, staticRenderFns } from "./TarjetaChat.vue?vue&type=template&id=24721f60&scoped=true&"
import script from "./TarjetaChat.vue?vue&type=script&lang=js&"
export * from "./TarjetaChat.vue?vue&type=script&lang=js&"
import style0 from "./TarjetaChat.vue?vue&type=style&index=0&id=24721f60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24721f60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VIcon,
})
